import React, { Component } from 'react';

import './preloader.css';

export default class Preloader extends Component {
  render() {
    return (
      <div className="preloader" style={this.props.style}>
        <div className="preloader-inner-1" style={this.props.cubeStyle} />
        <div className="preloader-inner-2" style={this.props.cubeStyle} />
      </div>
    );
  }
}

export const DefaultPreloader = () => <Preloader cubeStyle={{ backgroundColor: '#5080c5' }} />;



// WEBPACK FOOTER //
// ./src/widgets/Preloader/index.js